export const carta = {
  pollos: {
    title: "Pollos Asados",
    icon: "ri-fire-fill",
    items: [
      { name: "Pollo Entero", desc: "", price: "13.00 €" },
      { name: "1/2 Pollo", desc: "", price: "7.00 €" },
      { name: "Oferta Nº1", desc: "1 pollo entero, patatas fritas grandes y mahonesa o ali oli", price: "18.00 €" },
      { name: "Oferta Nº2", desc: "1 pollo entero, patatas fritas grandes, ensaladilla rusa, bebida 2L y mahonesa o ali oli", price: "22.00 €" },
      { name: "Oferta Nº3", desc: "1 pollo entero, patatas fritas grandes, ensaladilla rusa, nuggets, bebida 1L mahonesa o ali oli", price: "24.00 €" },
      { name: "Oferta Nº4", desc: "1 pollo entero, patatas fritas grandes, pimientos fritos, bebida 2L, pan y ali oli", price: "26.00 €" },
      { name: "Oferta Nº5", desc: "1 pollo entero, tortilla, ensaladilla rusa, ensalada mixta, croquetas, aceitunas, bebida 2L y 2 de ali oli", price: "32.00 €" },
      { name: "Oferta Nº6", desc: "2 pollos enteros, patatas fritas grandes, ensaladilla rusa, nuggets, tortilla, aceitunas, pan, bebida 2L y ali oli", price: "43.00 €" },
      { name: "Super 1", desc: "1/2 pollo asado, patatas fritas y bebida 1L", price: "12.00 €" },
      { name: "Super 2", desc: "1/2 pollo asado, ensaladilla rusa y bebida 1L", price: "12.00 €" },
      { name: "Lote A", desc: "2 pollos enteros, patatas fritas grandes, bebida 2L y 2 ali oli", price: "31.00 €" },
      { name: "Lote B", desc: "1 pollo entero, tortilla casera y ali oli", price: "18.00 €" },
      { name: "Lote C", desc: "1 pollo entero, ensaladilla rusa o mixta", price: "16.00 €" },
      { name: "Lote XXL", desc: "2 pollos enteros, patatas fritas grandes, tortilla, 2 barras de pan y 2 ali oli", price: "34.00 €" },
    ],
  },
  bocatas: {
    title: "Bocatas",
    icon: "ri-bread-fill",
    items: [
      { name: "Bocata Nº1", desc: "Hamburguesa de pollo con verduras y salsas", price: "4.50 €" },
      { name: "Bocata Nº2", desc: "Hamburguesa de ternera con verduras y salsas", price: "6.00 €" },
      { name: "Bocata Nº3", desc: "Hamburguesa de ternera, huevo, queso, bacon, verduras y salsas", price: "6.50 €" },
      { name: "Bocata Nº4", desc: "Hamburguesa de pollo, huevo, queso, bacon, verduras y salsas", price: "5.50 €" },
      { name: "Bocata Nº5", desc: "Lomo, huevo, bacon, verduras y salsas", price: "5.00 €" },
      { name: "Bocata Nº6", desc: "Lomo, pollo asado, huevo, queso, bacon, verduras y salsas", price: "5.00 €" },
      { name: "Bocata Nº7", desc: "Lomo, pollo asado, patatas fritas (dentro), huevo, queso, bacon y salsas", price: "5.50 €" },
      { name: "Bocata Nº8", desc: "Lomo adobado, huevo, verdura y salsas", price: "4.30 €" },
      { name: "Bocata Nº9", desc: "Filete de pollo, huevo, queso, bacon, verduras y salsas", price: "5.50 €" },
      { name: "Bocata Nº10", desc: "Pollo asado, bacon, verduras y salsas", price: "4.00 €" },
      { name: "Bocata Nº11", desc: "Pollo asado, patatas fritas dentro, verduras y salsas", price: "4.00 €" },
      { name: "Bocata Nº12", desc: "Pollo asado, huevo, verduras y salsas", price: "4.30 €" },
      { name: "Bocata Nº13", desc: "Lomo, verduras y salsas", price: "4.00 €" },
      { name: "Bocata Nº14", desc: "Filete de pollo, verduras y salsas", price: "4.00 €" },
      { name: "Bocata Nº15", desc: "Lomo adobado, huevo, patatas fritas dentro y salsas", price: "4.50 €" },
      { name: "Bocata Nº16", desc: "Lomo adobado, verduras y salsas", price: "4.00 €" },
      { name: "Bocata Nº17 · Serranito Lomo", desc: "Lomo, jamón serrano, queso, pimientos, bacon, verduras y salsas", price: "5.50 €" },
      { name: "Bocata Nº18", desc: "Tortilla de patatas, bacon y salsas", price: "4.00 €" },
      { name: "Bocata Nº19 · Serranito Pollo", desc: "Pollo, queso, pimientos, bacon, verduras y salsas", price: "5.50 €" },
      { name: "Bocata Nº20 · Serranito Pollo Asado", desc: "Pollo asado, queso, pimientos, bacon, verduras y salsas", price: "5.50 €" },
      { name: "Bocata Nº21", desc: "Filete de pollo, patatas fritas dentro, huevo y salsas", price: "4.50 €" },
    ],
  },
  menus: {
    title: "Menús Bocatas",
    icon: "ri-restaurant-fill",
    items: [
      { name: "Menú Bocata Nº1", desc: "Hamburguesa de ternera, verduras, patatas fritas, salsas y bebida 1 lata", price: "7.00 €" },
      { name: "Menú Bocata Nº2", desc: "Pollo asado, verduras, patatas fritas, salsas y bebida 1 lata", price: "6.00 €" },
      { name: "Menú Bocata Nº3", desc: "Lomo, verduras, patatas fritas, salsas y bebida 1 lata", price: "6.00 €" },
      { name: "Menú Bocata Nº4", desc: "Filete de pollo, verduras, patatas fritas, salsas y bebida 1 lata", price: "6.00 €" },
      { name: "Menú Bocata Nº5", desc: "Lomo adobado, huevo, patatas fritas dentro, salsas y bebida 1 lata", price: "5.50 €" },
      { name: "Menú Bocata Nº6", desc: "Hamburguesa de pinchito, verduras, salsas y bebida 1 lata", price: "6.00 €" },
      { name: "Menú Bocata Nº7", desc: "Hamburguesa de pollo, verduras, patatas fritas, salsas y bebida 1 lata", price: "6.00 €" },
      { name: "Menú Bocata Serranito", desc: "Jamón serrano, lomo, pimientos fritos, salsas y bebida 1 lata", price: "6.50 €" },
      { name: "Menú Bocata Empanado", desc: "Pollo empanado, verduras, patatas fritas y bebida 1 lata", price: "6.50 €" },
    ],
  },
  menusInfantil: {
    title: "Menú Infantil",
    icon: "ri-restaurant-2-fill",
    items: [
      { name: "Menú Empanado", desc: "Dos pechugas de pollo con patatas y bebidas", price: "6.50 €" },
      { name: "Menú Nuggets", desc: "Siete nuggets de pollo con patatas y bebida", price: "6.50 €" },
    ],
  },
  variados: {
    title: "Variados",
    icon: "ri-star-smile-fill",
    items: [
      { name: "Croquetas", desc: "De pollo (8 unidades)", price: "7.00 €" },
      { name: "Nuggets", desc: "De pollo (11 unidades)", price: "6.50 €" },
      { name: "Tortilla", desc: "Tortilla de patatas casera", price: "7.00 €" },
      { name: "Pimientos Fritos", desc: "Pimientos fritos de guarnición", price: "6.50 €" },
      { name: "Mahonesa", desc: "Salsa mahonesa casera", price: "1.60 €" },
      { name: "Ali Oli", desc: "Salsa ali oli casera", price: "1.60 €" },
      { name: "Ketchup", desc: "Salsa ketchup", price: "1.60 €" },
    ],
  },
  ensaladas: {
    title: "Ensaladas",
    icon: "ri-leaf-fill",
    items: [
      { name: "Ensalada Rusa · Pequeña", desc: "Ensaladilla rusa tradicional", price: "3.00 €" },
      { name: "Ensalada Rusa · Grande", desc: "Ensaladilla rusa tradicional", price: "5.00 €" },
      { name: "Ensalada Mixta · Pequeña", desc: "Verduras variadas", price: "3.00 €" },
      { name: "Ensalada Mixta · Grande", desc: "Verduras variadas", price: "5.00 €" },
      { name: "Ensalada de Pollo · Pequeña", desc: "Ensalada con pollo", price: "3.00 €" },
      { name: "Ensalada de Pollo · Grande", desc: "Ensalada con pollo", price: "5.00 €" },
    ],
  },
  patatas: {
    title: "Patatas Fritas",
    icon: "ri-separator",
    items: [
      { name: "Patatas Fritas · Grande", desc: "Ración grande de patatas fritas", price: "5.90 €" },
      { name: "Patatas Fritas · Mediana", desc: "Ración mediana de patatas fritas", price: "4.90 €" },
      { name: "Patatas Fritas · Pequeña", desc: "Ración pequeña de patatas fritas", price: "3.80 €" },
      { name: "Patatas Fritas · Mini", desc: "Ración mini de patatas fritas", price: "2.00 €" },
    ],
  },
} as const;